import { render, staticRenderFns } from "./CardsSkeleton.vue?vue&type=template&id=03a472da&"
import script from "./CardsSkeleton.vue?vue&type=script&lang=js&"
export * from "./CardsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CardsSkeleton.vue?vue&type=style&index=0&id=03a472da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports